export default () => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='100%' height='100%' transform='translate(0 0.5)' />
    <path
      d='M7.997 14.1463L14.5461 2.51129C14.614 2.39128 14.6451 2.25396 14.6356 2.1164C14.626 1.97883 14.5763 1.84711 14.4925 1.7376C14.4087 1.6281 14.2946 1.54564 14.1643 1.50049C14.034 1.45534 13.8933 1.44948 13.7597 1.48366L0.817285 4.76362C0.704731 4.79138 0.600861 4.84673 0.515044 4.92467C0.429227 5.00261 0.364164 5.10069 0.325725 5.21006C0.287285 5.31943 0.276679 5.43665 0.294862 5.55114C0.313045 5.66564 0.359445 5.7738 0.429878 5.86588L2.39444 8.44482C2.60812 8.72407 2.99853 8.80609 3.30342 8.62592L12.0027 3.64283L4.91458 10.7314C4.66525 10.9842 4.64237 11.3825 4.85606 11.6618L6.83179 14.2321C7.13522 14.6287 7.75233 14.5904 7.997 14.1463Z'
      fill='currentColor'
    />
  </svg>
)
